export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/lottery/village/query`,
                data
            });
        },
        list(data) {
            return http.json({
                url: `/lottery/village/listVillage`,
                data
            });
        },
        saveInfo(data) {
            return http.json({
                url: '/lottery/village/save',
                data
            })
        },

        getPrizeInfo(data) {
            return http.json({
                url: `/lottery/village/get?id=${data.id}`
            })
        },

        delete(data) {
            return http.json({
                url: `/lottery/village/delete?id=${data[0].id}`,
                data
            })
        },

    };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/lottery.js